import { render } from "./DhTableData.vue?vue&type=template&id=871ceb28"
import script from "./DhTableData.vue?vue&type=script&lang=ts"
export * from "./DhTableData.vue?vue&type=script&lang=ts"
script.render = render

export default script